module.exports = __webpack_public_path__ + "static/media/deletar-cupom.b65fd075.png";